import { useMemo } from 'react';

import Chip from '@/components/ui/Chip';

import { useGetNonceRolesQuery } from '@/store/api/services/users/users';

interface UsersRoleColumnV2Props {
  value?: number;
}

export const UsersRoleColumnV2 = ({ value }: UsersRoleColumnV2Props) => {
  const { data = [] } = useGetNonceRolesQuery();

  const label = useMemo(() => data.find(({ id }) => id === value)?.name || value, [data, value]);

  return <Chip size="small" color="primary" label={label} />;
};
